export const stringToBoolean = (boolValue: string): boolean => {
  return boolValue.toLowerCase() === "true";
};
